import {Component, ElementRef, EventEmitter, OnInit, Output, Renderer2} from '@angular/core';
import {AsyncPipe, NgClass, NgIf} from "@angular/common";
import {Observable, Subject} from "rxjs";
import {SidebarTab} from "../../state/ui/ui.state";
import {Store} from "@ngrx/store";
import {selectActiveTabIndex, selectIsAsideOpen, selectIsClosing, selectReportSidebarTabs} from "../../state/ui/ui.selectors";
import {takeUntil} from "rxjs/operators";
import * as UiActions from "../../state/ui/ui.actions";
import {toggleReportSidebarTab} from "../../state/ui/ui.actions";
import {fetchReport} from "../../state/search/search.actions";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-report-sidebar',
  standalone: true,
  imports: [
    AsyncPipe,
    NgIf,
    NgClass
  ],
  templateUrl: './report-sidebar.component.html',
  styleUrl: './report-sidebar.component.scss'
})
export class ReportSidebarComponent implements OnInit {

  @Output() dataEmitter: EventEmitter<any> = new EventEmitter();
  @Output() dataEmitter2: EventEmitter<any> = new EventEmitter();
  @Output() dataEmitter3: EventEmitter<any> = new EventEmitter();

  @Output() asideStateChange = new EventEmitter<{isOpen: boolean, isClosing: boolean}>();

  sidebarTabs$: Observable<SidebarTab[]>;
  activeTabIndex$: Observable<number | null>;
  isAsideOpen$: Observable<boolean>;
  isClosing$: Observable<boolean>;

  private destroy$ = new Subject<void>();
  private tabs: SidebarTab[] = [];

  constructor(private route: ActivatedRoute, private renderer: Renderer2, private el: ElementRef, private store: Store) {

    this.sidebarTabs$ = this.store.select(selectReportSidebarTabs);
    this.activeTabIndex$ = this.store.select(selectActiveTabIndex);
    this.isAsideOpen$ = this.store.select(selectIsAsideOpen);
    this.isClosing$ = this.store.select(selectIsClosing);

  }

  ngOnInit(): void {
    // Keep track of current tabs state
    this.sidebarTabs$
      .pipe(takeUntil(this.destroy$))
      .subscribe(tabs => {
        this.tabs = tabs;
        this.dataEmitter.emit(tabs);
      });

    // Handle aside state changes
    this.isAsideOpen$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isOpen => {
        this.dataEmitter2.emit(isOpen);
      });

    // Handle combined state for aside changes
    this.store.select(state => ({
      isOpen: selectIsAsideOpen(state),
      isClosing: selectIsClosing(state)
    }))
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ isOpen, isClosing }) => {
        this.asideStateChange.emit({ isOpen, isClosing });
      });
  }


  showAside: boolean = false
  edit: boolean = false

  sidebarTabs = [
    { id: 1, name: 'Tags', current: true },
    { id: 2, name: 'Assistant', current: false },
    { id: 3, name: 'Edit', current: false },
    { id: 4, name: 'Notes', current: false },
    { id: 5, name: 'Emails', current: false },
    { id: 6, name: 'CRM', current: false },
  ]

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeSidebarTab(tabIndex: number): void {
    const isCurrentlyActive = this.tabs[tabIndex]?.current;

    this.store.dispatch(UiActions.toggleReportSidebarTab({
      tabIndex,
      isClosing: isCurrentlyActive || false
    }));

    // Check if the tab is Tags AND it's being opened (not already active)
    if (tabIndex === 0 && !isCurrentlyActive) {
      const reportId = parseInt(this.route.snapshot.paramMap.get('id'));
      if (reportId) {
        this.store.dispatch(fetchReport({ reportId }));
      }
    }
  }

  toggleEdit() {
    // console.log('toggleEdit')
    this.edit = !this.edit
    this.dataEmitter3.emit(this.edit);
  }

}
